import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

/**
 * GET /v1/resource-manager/cloud-connectivity
 * Get list of Cloud Connectivity services
 */
export function getCloudConnectivityServices(token: string) {
  return axios.get(`${API_URL}/v1/resource-manager/ke-cloud`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

/**
 * GET /v1/resource-manager/cloud-connectivity/:id
 * Get Cloud Connectivity service by ID
 */
export function getCloudConnectivityServiceById(token: string, id: string | number) {
  return axios.get(`${API_URL}/v1/resource-manager/ke-cloud/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

/**
 * POST /v1/resource-manager/cloud-connectivity
 * Create new Cloud Connectivity service
 */
export interface AddCloudConnectivityPayload {
  kontrolEdgePortId: number;
  mbps: number;
  vlan: number;
  automaticVlan: boolean;
  subscriptionId: string;
  terms: number;
  name: string;
  tag: string[];
  provider: string;
  providerId: string;
  providerAccount: number;
  cloud: string;
  account: string;
  monitoring: {
    enable: boolean;
    maintenance_mode: boolean;
  };
}

export function addCloudConnectivityService(token: string, payload: AddCloudConnectivityPayload) {
  return axios.post(`${API_URL}/v1/resource-manager/ke-cloud`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}

/**
 * PUT /v1/resource-manager/cloud-connectivity/:id
 * Update Cloud Connectivity service
 */
export interface UpdateCloudConnectivityPayload {
  name: string;
  mbps: number;
  tag: string[];
}

export function updateCloudConnectivityService(
  token: string,
  id: string | number,
  payload: UpdateCloudConnectivityPayload
) {
  const encodedId = encodeURIComponent(String(id));
  return axios.put(`${API_URL}/v1/resource-manager/ke-cloud/${encodedId}`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}

/**
 * DELETE /v1/resource-manager/cloud-connectivity/:id
 * Delete Cloud Connectivity service
 */
export function deleteCloudConnectivityService(token: string, id: string | number) {
  const encodedId = encodeURIComponent(String(id));
  return axios.delete(`${API_URL}/v1/resource-manager/ke-cloud/${encodedId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

